import React, { useState } from 'react'

import Layout from '../../components/layout'

import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import { graphql } from 'gatsby'

import { nanoid } from 'nanoid'
import MerchModal from '../../components/shop/merchModal'
import Cart from '../../components/shop/cart'

export const query = graphql`
    query {
        allContentfulMerch {
            nodes {
                title
                modelImage {
                    gatsbyImageData(width: 300, quality: 100, placeholder: BLURRED)
                }
                description
                collection
                price
            }
        }
    }
`

const Merch = ({ data }) => {
    
    const pause = 'pause'
    const play = 'play'

    const toggleAnimation = (toggle) => {
        const columns = document.getElementsByClassName('merch-column')

        if(toggle === pause) {
            for (const column of columns) {
                column.className += " paused"
            }
        } else if(toggle === play){
            for (const column of columns) {
                column.classList.remove('paused')
            }
        }
    }

    const [animationState, setAnimationState] = useState(true)

    const containerStyle = animationState ? {
        position: 'fixed',
        height: '100vh'
    } : {
        position: 'absolute',
        height: 'unset'
    }

    const [ merchModalProps, setMerchModalProps ] = useState(null) //would be good to set the type of this beforehand
    const [ isMerchModalOpen, setIsMerchModalOpen ] = useState(false)

    const openMerchModal = (title, description, price, collection, modelImage, size) => {
        setMerchModalProps({
            title,
            description,
            collection,
            price,
            modelImage,
            size
        })

        setIsMerchModalOpen(true)
    }

    const [ cart, setCart ] = useState([])
    
    const addToCart = (item) => {
        setCart([...cart, item])
    }

    return (
        <Layout>
            <div className="merch-animation-toggle is-size-4">
                Display mode:{` `}
                <span className={animationState ? 'active-toggle' : '' } onClick={ () => setAnimationState(true) } onKeyDown={() => setAnimationState(true)} tabIndex={0} role="button">Elevate</span> 
                {` `}|{` `}<span className={!animationState ? 'active-toggle' : '' } onClick={() => setAnimationState(false) } onKeyDown={() => setAnimationState(false)} tabIndex={-1} role="button">Still</span>
            </div>
            <div id="merch-container" style={containerStyle}>
                {
                    data.allContentfulMerch.nodes
                        .sort((a,b) => (a.collection.toLowerCase() > b.collection.toLowerCase()) ? 1 : ((b.collection.toLowerCase() > a.collection.toLowerCase()) ? -1 : 0)) //sort by collection
                        .map(({ title, description, price, collection, modelImage }, index) => {
                        // place image in the appropriate column
                        const columnIndex = (index+1) % 3 === 0 ? '3' : (index+1) % 3
                        const size = undefined
                        return <div className={`merch-column ${animationState ? 'animate' : ''} column-${columnIndex}`} key={nanoid()}
                                    onClick={() => openMerchModal(title, description, price, collection, modelImage, size)} onKeyDown={() => openMerchModal(title, description, price, collection, modelImage, size)}
                                    role="button" tabIndex={-1}
                                >
                                    <GatsbyImage image={getImage(modelImage)} alt="image of merch" className="merch-item" 
                                        onMouseOver={() => toggleAnimation(pause)} onMouseOut={() => toggleAnimation(play)}
                                        onFocus={() => toggleAnimation(pause)} onBlur={() => toggleAnimation(play)}
                                    />
                                </div>
                    })
                }
            </div>

            { isMerchModalOpen && <MerchModal attributes={merchModalProps} setIsMerchModalOpen={setIsMerchModalOpen} addToCart={addToCart} />
            }

            <Cart cart={cart} itemCount={cart.length} />
        </Layout>
    )
}

export default Merch
